import '../css/style.scss'

import Login from './components/login'
import Scene from './components/scene'
import Lottery from './components/lottery'

let currentSection = 1
const init = async () => {
  Scene.UI_sceneReset()

  // 无需登录，界面初始化
  await Scene.api_sceneStatusInit()

  if (TlPassport.isLoggedIn()) {
    Login.UI_logined()
  } else {
    Login.UI_logout()
  }
  Lottery.api_lotteryInit()
  BItrack()
}
const BItrack = function () {
  _jc_ping.push([
    '_trackBlockClick',
    'BF3Qru',
    location.href + '#pn' + currentSection,
  ])
}

$(function () {
  $('.swiper-slide').not(':first-child,:last-child').addClass('fp-v-center')

  let lastLeave = new Date()
  $('.swiper-wrapper').fullpage({
    sectionSelector: '.swiper-slide',
    scrollingSpeed: 700,
    scrollOverflow: true,
    verticalCentered: false,
    onLeave: function (index, nextIndex) {
      const now = new Date()
      if (now - lastLeave < 1000) {
        return false
      } else {
        lastLeave = now
      }
      $('.swiper-pagination a')
        .removeClass('active')
        .eq(nextIndex - 1)
        .addClass('active')
    },
    afterLoad: function () {
      BItrack()
    },
  })

  $('.swiper-pagination a').on('click', function () {
    $.fn.fullpage.moveTo($(this).index() + 1)
  })

  $('.js-tab').each(function () {
    var _nav = $(this).find('.tab')
    var _item = $(this).find('.tab-pn')
    _nav.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      asNavFor: _item,
    })
    _item.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      draggable: false,
      asNavFor: _nav,
    })
  })

  $('.btn-gotop').click(function () {
    $.fn.fullpage.moveTo(1)
  })

  $('.js-focus').each(function () {
    var $focus_list = $(this).find('.focus-list')
    $focus_list.slick({
      slidesToScroll: 1,
      variableWidth: true,
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: false,
      focusOnSelect: true,
    })
  })

  $(document).click(function (e) {
    if ($(e.target).parents('.share-c').length === 0) {
      $('.code').hide()
    }
  })

  pandora.use(['share'], function (Share) {
    new Share({
      element: '.share',
      showLabel: false,
      shareList: 'qq,weixin,tsina',
      importStyle: false,
      customShare: {
        weixin: {
          position: 'left',
        },
      },
      shImg: 'https://cdn.tlsy.cy.com/a/act/2019/0315/img/img-share.jpg',
    })
  })

  $('.yq-slide')
    .find('.item')
    .hover(function () {
      $(this).addClass('active').siblings('.item').removeClass('active')
    })

  $(
    '.dialog .mask, .dialog .btn-close,.dialog .btn-define:not([data-btn-bind]):not([data-btn-yylb])'
  ).on('click', function () {
    $('.dialog').hide()
    $.fn.fullpage.setAllowScrolling(true, 'up, down')

    $('.dialog .form-error').length > 0 && $('.form-error').text('').hide()
  })
  init()
})
